import service from '@/utils/request'; // @Tags saleDetail
// @Summary 销售明细
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body request.PageInfo true "分页获取列表"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /orderManage/order/getList [get]

export var GetSaleDetailList = function GetSaleDetailList(params) {
  return service({
    url: '/orderManage/order/getList',
    method: 'get',
    params: params
  });
}; // 下载油品订单
// @Tags GoodsManage
// @Summary 下载油品订单
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "下载油品订单"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /orderManage/order/download/oil/order [post]

export var DownloadOilOrderList = function DownloadOilOrderList(data) {
  return service({
    url: '/orderManage/order/download/oil/order',
    method: 'post',
    data: data
  });
}; // @Tags saleDetail
// @Summary 销售明细
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body request.PageInfo true "分页获取列表"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /shop/v1/order/detail/getList [get]

export var GetSaleDetail = function GetSaleDetail(params) {
  return service({
    url: '/orderManage/order/detail/getList',
    method: 'get',
    donNotShowLoading: params && params.donNotShowLoading ? params.donNotShowLoading : true,
    params: params
  });
}; // @Tags 申请退款
// @Summary 申请退款
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body request.PageInfo true "分页获取列表"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /orderManage/refund/request [post]

export var BairunOrderRefund = function BairunOrderRefund(data) {
  return service({
    url: '/orderManage/refund/request',
    method: 'post',
    data: data
  });
}; // 销售明细
// @Tags GoodsManage
// @Summary 分页获取列表
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "分页获取列表"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /orderManage/order/shop/items/getList [get]

export var GetShopOrderDetailList = function GetShopOrderDetailList(params) {
  return service({
    url: '/orderManage/order/shop/items/getList',
    method: 'get',
    params: params
  });
}; // 下载销售明细
// @Tags GoodsManage
// @Summary 下载
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "下载"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /orderManage/order/download/shop/items [post]

export var DownloadShopOrderDetail = function DownloadShopOrderDetail(data) {
  return service({
    url: '/orderManage/order/download/shop/items',
    method: 'post',
    data: data
  });
}; // 赠品记录
// @Tags GoodsManage
// @Summary 分页获取列表
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "分页获取列表"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /orderManage/gift/getList [get]

export var GetShopGiftDetailList = function GetShopGiftDetailList(params) {
  return service({
    url: '/orderManage/gift/getList',
    method: 'get',
    params: params
  });
}; // 下载赠品记录
// @Tags GoodsManage
// @Summary 下载赠品记录
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "下载赠品记录"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /orderManage/gift/download [post]

export var DownloadShopGiftDetail = function DownloadShopGiftDetail(data) {
  return service({
    url: '/orderManage/gift/download',
    method: 'post',
    data: data
  });
}; // 赠品统计
// @Tags GoodsManage
// @Summary 分页获取列表
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "分页获取列表"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /orderManage/gift/groupby/goods/getList [get]

export var GetShopGiftCountList = function GetShopGiftCountList(params) {
  return service({
    url: '/orderManage/gift/groupby/goods/getList',
    method: 'get',
    params: params
  });
}; // 下载赠品统计
// @Tags GoodsManage
// @Summary 下载赠品统计
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "下载赠品统计"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /orderManage/gift/groupby/goods/download [post]

export var DownloadShopGiftCount = function DownloadShopGiftCount(data) {
  return service({
    url: '/orderManage/gift/groupby/goods/download',
    method: 'post',
    data: data
  });
};